import React from "react";
import Navigation from "../components/navigation";

import "aos/dist/aos.css";

import { Helmet } from "react-helmet";
import { check_login } from "../auth/auth";
import { useEffect } from "react";
import { useState } from "react";
import QRCode from "react-qr-code";

function MijnGegevens() {
  const [claims, setClaims] = useState<any>(null);
  useEffect(() => {
    let claims: any = JSON.parse(check_login(false));
    setClaims(claims);
  }, []);

  return (
    <>
      {!!check_login(true) ? (
        <div className="dark:bg-zinc-900">
          <Navigation />
          <Helmet>
            <title>Mijn Gegevens - Hermes Gent</title>
            <meta name="description" content={"Hermes Gent - mijn gegevens"} />
          </Helmet>
          <div className="lg:w-8/12 w-11/12 pt-20 pb-40 mx-auto text-zinc-700 dark:text-zinc-300">
            <div className="flex flex-col items-center">
              <h1 className="text-4xl font-bold mb-8">
                {claims?.first_name} {claims?.last_name}
              </h1>
              {claims?.user_id ? (
                <div className="flex items-center justify-center p-4 rounded-xl bg-gradient-to-br from-blue-500 to-purple-500">
                  <div className="bg-white p-4 rounded-xl">
                    <QRCode value={claims?.user_id} />
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default MijnGegevens;
